import _ from "lodash"

const PLAN_GOALS = "plan_goals"
const PARTICIPANT_NOTES_MULTIBLOCK = "participant_notes_multiblock"
const STAFF_NOTES_MULTIBLOCK = "staff_notes_multiblock"

function isIsoDate(str) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false
  const d = new Date(str)
  return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str // valid date
}

function formatValue(value) {
  if (isIsoDate(value)) {
    const date = new Date(value)
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${month}/${day}/${year}`
  }
  return value
}

function formatKey(key) {
  return _.startCase(_.toLower(key)).replaceAll("_", " ") + ": "
}

export default function TypeMultiField({ value, name, multi_fields }) {
  if (_.isEmpty(value)) {
    return <div>No data available.</div>
  }

  let data = ""

  switch (name) {
    case PLAN_GOALS:
      data = _.map(value, (field) => {
        if (_.isEmpty(field) || !_.isObject(field)) {
          return null
        }

        return `<div>${_.map(_.keys(field), (key) => {
          if (key === "date_created") {
            return null
          }
          const foundObject = _.find(multi_fields, function (o) {
            return o.field_name === key
          })
          let keyLabel = foundObject?.field_label

          const keyValue = field[key]
          if (_.isArray(keyValue) && !_.isEmpty(keyValue)) {
            let finalValue = `<strong>${keyLabel}: </strong>`
            _.forEach(keyValue, (item) => {
              if (_.isObject(item) && !_.isEmpty(item)) {
                const allValues = _.values(item)
                if (_.isArray(allValues)) {
                  const finalValues = _.first(allValues)
                  finalValue += finalValues + " "
                }
              }
            })
            return finalValue
          }
          return `<strong>${keyLabel}: </strong>${formatValue(keyValue)}<br>`
        })}</div>`
      })
      break
    default:
      data = _.map(value, (field) => {
        if (_.isEmpty(field) || !_.isObject(field)) {
          return null
        }
        return (
          _.map(_.keys(field), (key) => {
            const foundObject = _.find(multi_fields, function (o) {
              return o.field_name === key
            })
            let multi_field_second = foundObject?.multi_fields || null

            let keyLabel = formatKey(key)
            const keyValue = field[key]
            if (_.isArray(keyValue) && !_.isEmpty(keyValue)) {
              if (keyLabel === "Participant Note List: ") {
                keyLabel = "Participant Name: "
              }
              let finalValue = `<strong>${foundObject?.field_label || keyLabel}</strong>`
              switch (name) {
                case PARTICIPANT_NOTES_MULTIBLOCK: {
                  _.forEach(keyValue, (item) => {
                    finalValue += item.name + "<br>"
                  })
                  break
                }
                default: {
                  finalValue += "<br>"
                  _.forEach(keyValue, (item) => {
                    if (_.isObject(item) && !_.isEmpty(item)) {
                      const allValues = _.values(item)
                      const keys = _.keys(item)
                      if (_.isArray(allValues)) {
                        _.forEach(allValues, (value, index) => {
                          const foundObject = _.find(
                            multi_field_second,
                            function (o) {
                              return o.field_name === keys[index]
                            }
                          )
                          finalValue += `&nbsp;&nbsp;&bull;&nbsp;${
                            foundObject?.field_label
                          }: ${formatValue(value)}<br>`
                        })
                      }
                    } else {
                      finalValue += item + "<br>"
                    }
                  })

                  break
                }
              }
              return finalValue
            }
            if (_.isObject(keyValue)) {
              switch (name) {
                case STAFF_NOTES_MULTIBLOCK:
                  return `<strong>Staff:</strong> ${keyValue.label}<br>`
                default: {
                  const newData = _.map(keyValue, (newValue) => {
                    let newDataExtra = _.map(_.keys(newValue), (newKey) => {
                      if (_.includes(newKey, "_id")) {
                        return null
                      }
                      const newkeyValue = newValue[newKey]
                      return `${formatKey(newKey)}: ${newkeyValue}`
                    })
                    return `<strong>${keyLabel}</strong>${newDataExtra}<br>`
                  })
                  return `${newData}<br>`
                }
              }
            } else {
              return `<strong>${keyLabel}</strong>${formatValue(keyValue)}<br>`
            }
          })
        )
      })
      break
  }

  if (name === PARTICIPANT_NOTES_MULTIBLOCK) {
    const orderedData = []
    if (_.isArray(data)) {
      _.forEach(data, (item) => {
        const newData = _.split(item, "<br>,")
        const reversedData = _.reverse(newData)
        reversedData[0] = _.replace(reversedData[0], "<br><br>", "<br>")
        reversedData[reversedData.length - 1] =
          reversedData[reversedData.length - 1] + "<br><br>"
        orderedData.push(_.join(reversedData, ""))
      })
      data = orderedData
    }
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: _.sortBy(data, ["index"])
          .toString()
          .replaceAll(",", "")
          .replaceAll("<p>", "")
          .replaceAll("</p>", ""),
      }}
    />
  )
}